<template>
  <svg
    class="brand-wordmark"
    :viewBox="wordmark.viewBox"
    role="img"
    aria-label="MANTRAZ"
    focusable="false"
  >
    <g :transform="wordmark.groupTransform">
      <path
        v-for="(letter, i) in wordmark.letters"
        :key="i"
        class="brand-wordmark__letter"
        :style="{ '--i': i }"
        :d="letter.d"
        :transform="letter.transform"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<script>
import { LOGO_WORDMARK } from '@/util/auth/brandLogoPaths';

export default {
  name: 'BrandWordmark',
  data() {
    return { wordmark: LOGO_WORDMARK };
  },
};
</script>

<style>
.brand-wordmark { display: block; height: 1em; width: auto; }
</style>
